<template>
  <div v-if='data'>
    <div style="width:100%;height:267px;" v-bind:id="id"></div>
  </div>
</template>
<script>
import { getUUID } from '../../utils/util'
let unwatch, myChart
export default {
  name: 'BarChArt',
  components: {},
  data() {
    return {
      id: getUUID()
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    total: {
      type: Number
    }
  },
  methods: {
    drawRingGraph(id) {
      let _this = this
      myChart = echarts2.init(document.getElementById(id))

      var option
      let data = this.data

      unwatch = this.$watch(
        'data',
        function(newvalue, oldvalue) {
          if (newvalue.seriseData != null) {
            console.log(newvalue)
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
    set(data) {
      
      var option
      option = {
        color: [
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#18B0DD' }, //柱图渐变色
            { offset: 1, color: '#2A80E8' } //柱图渐变色
          ]),
          '#0071FB',
          '#FB7800'
        ],
        grid: {
          x: '5%', //左侧与y轴的距离
          y: '18%', //top部与x轴的距离
          x2: '2%', //右侧与y轴的距离
          y2: '10%' //bottom部与x轴的距离
        },
        title: {
          subtext: data.unit
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false,
          top: '5%',
          right: '0%'
          // data: ['蒸发量', '降水量']
        },
        toolbox: {
          show: true
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: data.xdata
          }
        ],
        yAxis: [
          {
            type: 'value',
            minInterval:1,
          }
        ],
        series: data.seriseData
      }
      myChart.setOption(option)
      window.addEventListener('resize', function() {
        myChart.resize()
      })
    }
  },
  mounted() {
      this.drawRingGraph(this.id)
      console.log(this.id)
  },
  created() {},
  beforeDestroy() {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!myChart?.isDisposed) {
      myChart.dispose()
    }
  }
}
</script>
<style lang="less" scoped>
</style>
